// extracted by mini-css-extract-plugin
export default {"sectionHead":"sectionHead__YIqOGV","centeredTitle":"centeredTitle__Hm5Esn"};